export default [
	{
		key: 'clientName',
		title: 'Client Name',
		scopedSlots: {customRender: 'client'},
	}, {
		key: 'basePrice',
		title: 'Base Price',
		scopedSlots: {customRender: 'basePrice'}
	}, {
		key: 'adminFee',
		title: 'Admin Fee',
		scopedSlots: {customRender: 'adminFee'}
	}, {
		key: 'shareFee',
		title: 'Share Fee',
		scopedSlots: {customRender: 'shareFee'}
	}, {
		key: 'margin',
		title: 'Margin',
		scopedSlots: {customRender: 'margin'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 100,
		scopedSlots: {customRender: 'action'}
	}
]
